module.exports = __webpack_public_path__ + "img/VALOR_PASION1.f4fb2829.png";